export class DocumentsServe {
  public static USERPHOTOS =
    'https://qatarjetasdoc.virtualplace.online/fotosUsuario/';
  public static COVERPHOTOS =
    'https://tarjetasf.virtualplace.online/fotosPortada/';
  public static LOGO = 'https://tarjetasf.virtualplace.online/Logotipo/';
  public static CARDPHOTOS =
    'https://tarjetasf.virtualplace.online/fotosTarjeta/';
  public static DOCUMENTS = 'https://tarjetasf.virtualplace.online/Documentos/';
  public static IMAGESSERVICES =
    'https://tarjetasf.virtualplace.online/imagenesServicios/';
}
